/* eslint-disable max-len */
import {setParams} from '@/utils/constants';
import {decryptData, encryptData} from '@/utils/encryptionUtils';
import {getConfiguracionUsuario} from '@/api/services/configuracion-usuario/configuracion-usuario.api';
import {getConfigureAudit, getEnums, getDescriptionEnums} from '@/api/services/comun/comun.api';
import {getListPermisosByUnidadId} from '@/api/services/permiso/permiso.api';
import {getListPermisoPantalla} from '@/api/services/permiso-pantalla/permiso-pantalla.api';

/** Cargamos los permisos de pantalla para el menu y los roles del usuario */
async function getLoaderRolesData() {
  return Promise.all([
    getListPermisosByUnidadId(),
    getListPermisoPantalla(),
  ]);
}

async function getEnumsYDescription() {
  return Promise.all([
    getEnums(),
    getDescriptionEnums(),
  ]);
}

async function getUserData() {
  /** Datos del usuario ya logeado */
  const encryptedData = localStorage.getItem('_config');
  let configUserData = {};
  if (encryptedData) {
    configUserData = JSON.parse(decryptData(encryptedData));
  } else {
    /** Pedimos los datos del usuario*/
    const usuarioData = await getConfiguracionUsuario();
    /** Guardamos la unidadId */
    if (usuarioData.configuracion) {
      configUserData = JSON.parse(usuarioData.configuracion);
    }
    /** Guardamos el usuario */
    if (usuarioData.usuarioId) {
      configUserData.userId = usuarioData.usuarioId;
    }
    if (usuarioData.descargarDocumento != null) {
      configUserData.descargarDocumento = usuarioData.descargarDocumento;
    }
    if (usuarioData.emailDiario != null) {
      configUserData.emailDiario = usuarioData.emailDiario;
    }
    if (usuarioData.presentar != null) {
      configUserData.presentar = usuarioData.presentar;
    }
  }
  return configUserData;
}

async function loadRolesAndEnums(configUserData, store) {
  /** Cargamos los roles de pantalla y el rol del usuario cuando sea posible */
  if (
    configUserData.userId && configUserData.userId > 0 &&
    configUserData.unidadId && configUserData.unidadId > 0
  ) {
    setParams(configUserData.userId, configUserData.unidadId);
    const [enums, descriptionEnums] = await getEnumsYDescription();
    store.commit('enums/setListEnums', JSON.parse(enums));
    store.commit('enums/setListDescriptionEnums', JSON.parse(descriptionEnums));
    await handleImpersonation(configUserData);
    [configUserData.roles, configUserData.rolesPantalla] = await getLoaderRolesData();
  }
}

async function handleImpersonation(configUserData) {
  const impersonateData = sessionStorage.getItem('_impersonate');
  const impersonateUser = impersonateData ? JSON.parse(decryptData(impersonateData)) : null;
  if (impersonateUser) {
    setParams(impersonateUser.id, configUserData.unidadId);
    configUserData.impersonateUser = impersonateUser.id;
    configUserData.impersonateUserName = impersonateUser.nombre;
  } else {
    configUserData.impersonateUser = null;
    configUserData.impersonateUserName = null;
  }
}

/** Cargamos los roles y datos necesarios para el menu y funcionalidad de la web */
async function getRolesNew(store) {
  const configUserData = await getUserData();
  await loadRolesAndEnums(configUserData, store);
  /** Guardamos los datos del usuario en session */
  if (configUserData.userId) {
    localStorage.setItem(
      '_config',
      encryptData(JSON.stringify(configUserData)),
    );
  }

  return {
    roles: configUserData.roles ?? [],
    data: configUserData.rolesPantalla ?? [],
  };
}

export {getRolesNew, getConfigureAudit};
